import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { GeneralComponentsModule } from "../general components/general-components.module";
import { PopoverAnagraphActionsComponent } from "./popover-anagraph-actions/popover-anagraph-actions.component";
import { PopoverOptionsComponent } from "./popover-options/popover-options.component";
import { PopupChangePasswordComponent } from "./popup-change-password/popup-change-password.component";
import { PopupRequestNumericPasswordComponent } from "./popup-request-numeric-password/popup-request-numeric-password.component";
import { PopupAlarmComponent } from "./popup-alarm/popup-alarm.component";
import { PopupFastCheckinComponent } from "./popup-fast-checkin/popup-fast-checkin.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { PopupContentAddressMethodsComponent } from "./popup-content-address-methods/popup-content-address-methods.component";
import { PopupContentListNotificationComponent } from "./popup-content-list-notification/popup-content-list-notification.component";
import { ListSelectableModule } from "../list-selectable/list-selectable.module";
import { PopupSelectOperationComponent } from "./popup-select-operation/popup-select-operation.component";
import { GridPopupAlarmComponent } from "./grid-popup-alarm/grid-popup-alarm.component";
import { DuplicateObjectPopupComponent } from "./duplicate-object-popup/duplicate-object-popup.component";
import { PopupContentEtsImportComponent } from "./popup-content-ets-import/popup-content-ets-import.component";
import { PopupDeviceCreationComponent } from "./popup-device-creation/popup-device-creation.component";
import { PopupEnergyCoefficientComponent } from "./popup-energy-coefficient/popup-energy-coefficient.component";
import { PopupBACSCoefficientComponent } from "./popup-bacs-coefficient/popup-bacs-coefficient.component";
import { PopupAssociateExistingSinapsiDevice } from "./popup-associate-existing-sinapsi-device/popup-associate-existing-sinapsi-device";
import { PipesModule } from "src/pipes/pipes.module";
import { PopupConnectBoxManagementComponent } from "./popup-connect-box-management/popup-connect-box-management.component";
import { PopupExpensesNoteComponent } from "./popup-expenses-note/popup-expenses-note.component";
import { PopupDetailsExpensesNoteComponent } from "./popup-details-expenses-note/popup-details-expenses-note.component";
import { PopupEnvironmentCategoryComponent } from "./popup-environment-category/popup-environment-category.component";
import { PopoverActionMenuComponent } from "./popover-action-menu/popover-action-menu.component";
import { PopoverMultipleCommandsToolbarComponent } from "./popover-mutiple-commands-toolbar/popover-multiple-commands-toolbar.component";
import { PopupDocumentSecurityComponent } from "./popup-document-security/popup-document-security.component";
import { PopupDocumentSecurityTypesComponent } from "./popup-document-security-types/popup-document-security-types.component";
import { PopupVotingComponent } from "./popup-voting/popup-voting.component";
import { PopupVotingVoteComponent } from "./popup-voting-vote/popup-voting-vote.component";
import { SelectFieldComponent } from "src/components/general components/select-field/select-field.component";
import { PopupVotingAlertComponent } from "./popup-voting-alert/popup-voting-alert.component";
import { PopupSelectIntegrationComponent } from "./popup-select-integration/popup-select-integration.component";
@NgModule({
    declarations: [
        PopoverOptionsComponent,
        PopupChangePasswordComponent,
        PopoverAnagraphActionsComponent,
        PopupRequestNumericPasswordComponent,
        PopupAlarmComponent,
        PopupFastCheckinComponent,
        PopupContentAddressMethodsComponent,
        PopupContentListNotificationComponent,
        PopupSelectOperationComponent,
        GridPopupAlarmComponent,
        DuplicateObjectPopupComponent,
        PopupContentEtsImportComponent,
        PopupDeviceCreationComponent,
        PopupEnergyCoefficientComponent,
        PopupBACSCoefficientComponent,
        PopupAssociateExistingSinapsiDevice,
        PopupConnectBoxManagementComponent,
        PopupExpensesNoteComponent,
        PopupDetailsExpensesNoteComponent,
        PopupEnvironmentCategoryComponent,
        PopoverActionMenuComponent,
        PopoverMultipleCommandsToolbarComponent,
        PopupDocumentSecurityComponent,
        PopupDocumentSecurityTypesComponent,
        PopupVotingComponent,
        PopupVotingVoteComponent,
        PopupVotingAlertComponent,
        PopupSelectIntegrationComponent
    ],
    imports: [
    SelectFieldComponent,
        CommonModule,
        FormsModule,
        IonicComponentsModule,
        TranslatePipe, TranslateDirective,
        ReactiveFormsModule,
        GeneralComponentsModule,
        NgxDatatableModule,
        ListSelectableModule,
        PipesModule,
    ],
    exports: [
        PopoverOptionsComponent,
        PopupChangePasswordComponent,
        PopoverAnagraphActionsComponent,
        PopupRequestNumericPasswordComponent,
        PopupAlarmComponent,
        PopupFastCheckinComponent,
        PopupContentAddressMethodsComponent,
        PopupContentListNotificationComponent,
        PopupSelectOperationComponent,
        GridPopupAlarmComponent,
        DuplicateObjectPopupComponent,
        PopupContentEtsImportComponent,
        PopupDeviceCreationComponent,
        PopupEnergyCoefficientComponent,
        PopupBACSCoefficientComponent,
        PopupAssociateExistingSinapsiDevice,
        PopupConnectBoxManagementComponent,
        PopupExpensesNoteComponent,
        PopupDetailsExpensesNoteComponent,
        PopupEnvironmentCategoryComponent,
        PopoverActionMenuComponent,
        PopoverMultipleCommandsToolbarComponent,
        PopupDocumentSecurityComponent,
        PopupDocumentSecurityTypesComponent,
        PopupVotingComponent,
        PopupVotingVoteComponent,
        PopupVotingAlertComponent,
        PopupSelectIntegrationComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PopupModule { }
